import {Service} from '@s-ui/domain'

import UserRepositoriesFactory from '../Repositories/factory.js'
import {CreateWhatsappIntentsUserRequest} from '../Requests/CreateWhatsappIntentsUserRequest.js'
import UserServicesFactory from './factory.js'

export default class CreateWhatsappIntentsService extends Service {
  #repository
  #getCurrentUserService

  constructor({repository, getCurrentUserService}) {
    super()
    this.#repository = repository
    this.#getCurrentUserService = getCurrentUserService
  }

  static create({config}) {
    return new CreateWhatsappIntentsService({
      repository: UserRepositoriesFactory.httpUserRepository({config}),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({config})
    })
  }

  async execute({resourceType, resourceId}) {
    const currentUser = await this.#getCurrentUserService.execute()
    const request = CreateWhatsappIntentsUserRequest.create({resourceType, resourceId})

    if (currentUser) {
      return this.#repository.createWhatsappIntents({
        createWhatsappIntentsUserRequest: request,
        userEntity: currentUser
      })
    }

    return this.#repository.createWhatsappIntentsAsNotLoggedUser({
      createWhatsappIntentsUserRequest: request
    })
  }
}
